import _ from 'lodash';
import { connect } from 'react-redux';
import React, { PureComponent } from 'react';
import AreaSelect from '@/business-components/sale/AreaSelect';
import { Input, Button, Select, Icon, FormGroup, ButtonGroup, ImageUploader, PopOver, OverlayTrigger, Checkbox } from '@tencent/spaui';
import { enumMessages } from '@/utils/MessageUtils';
import { withApi } from '@tencent/react-aio';
import * as ActionTypes from '@/stores/sale/actions';
import globalStore from '@/stores';
import classNames from 'classnames';

const imgUploadUrl = '/ags/registration/upload';
const requiredFieldMap = {
  uname: { tip: '请输入公司名称', errField: 'unameErr' },
  websiteUrl: { tip: '请输入正确的公司网站，如:http://example.com/', errField: 'websiteUrlErr' },
  tmallAdvertiserAdtype: { tip: '请选择投放类型', errField: 'tmallAdvertiserAdtypeErr' },
  licenseNo: { tip: '请填写营业执照注册号三证合一统一社会信用代码', errField: 'licenseNoErr' },
  licenseImageUrl: { tip: '请上传营业执照', errField: 'imgUploadUrlErr' },
  areaCode: { tip: '请选择公司所在地', errField: 'areaCodeErr' },
  legalPersonName: { tip: '请输入法人姓名', errField: 'legalPersonNameErr' },
  legalPersonPositive: { tip: '请上传身份证正面', errField: 'legalPersonPositiveImageErr' },
  legalPersonNegative: { tip: '请上传身份证反面', errField: 'legalPersonNegativeImageErr' },
  legalPersonIdentityNo: { tip: '请输入法人身份证号', errField: 'legalPersonIdentityNoErr' },
};

const requiredFieldMapByGDT = {
  websiteUrl: { tip: '请输入正确的公司网站，如:http://example.com/', errField: 'websiteUrlErr' },
  tmallAdvertiserAdtype: { tip: '请选择投放类型', errField: 'tmallAdvertiserAdtypeErr' },
  licenseImageUrl: { tip: '请上传营业执照', errField: 'imgUploadUrlErr' },
  areaCode: { tip: '请选择公司所在地', errField: 'areaCodeErr' },
  legalPersonName: { tip: '请输入法人姓名', errField: 'legalPersonNameErr' },
  legalPersonPositive: { tip: '请上传身份证正面', errField: 'legalPersonPositiveImageErr' },
  legalPersonNegative: { tip: '请上传身份证反面', errField: 'legalPersonNegativeImageErr' },
  legalPersonIdentityNo: { tip: '请输入法人身份证号', errField: 'legalPersonIdentityNoErr' },
};

const requiredFieldMapByWeChat = {
  tmallAdvertiserAdtype: { tip: '请选择投放类型', errField: 'tmallAdvertiserAdtypeErr' },
  areaCode: { tip: '请选择公司所在地', errField: 'areaCodeErr' },
};

const basicInfoDisabledConfig = {
  unameDisabled: ['CUSTOMERSTATUS_NORMAL'],
  buyingTypeDisabled: ['CUSTOMERSTATUS_NORMAL', 'CUSTOMERSTATUS_DENIED', 'CUSTOMERSTATUS_PENDING', 'CUSTOMERSTATUS_FREEZE'],
  websiteUrlDisabled: [],
  licenseNoDisabled: ['CUSTOMERSTATUS_NORMAL'],
  licenseImageUrlDisabled: ['CUSTOMERSTATUS_NORMAL'],
  areaCodeDisabled: ['CUSTOMERSTATUS_NORMAL'],
  legalPersonNameDisabled: ['CUSTOMERSTATUS_NORMAL'],
  legalPersonPositiveDisabled: ['CUSTOMERSTATUS_NORMAL'],
  legalPersonNegativeDisabled: ['CUSTOMERSTATUS_NORMAL'],
  legalPersonIdentityNoDisabled: ['CUSTOMERSTATUS_NORMAL'],
};
const TMALL_ADVERTISER_ADTYPE = {
  FYEC: 1,
  TMALL: 2,
};

class BasicInfo extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      // agency_uid: '',
      // error提示
      unameErr: '',
      websiteUrlErr: '',
      tmallAdvertiserAdtypeErr: '',
      licenseNoErr: '',
      imgUploadUrlErr: '',
      areaCodeErr: '',
      legalPersonNameErr: '',
      legalPersonPositiveImageErr: '',
      legalPersonNegativeImageErr: '',
      legalPersonIdentityNoErr: '',
      showTmallAdvertiserAdType: false,
    };
    this.companyNameVerify = true;
    this.fetchCompanyNameVerify = _.debounce(this.fetchCompanyNameVerify, 1000);
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  componentWillReceiveProps(nextProps) {
    // this.setState({ agency_uid: nextProps.agencyUid });
  }

  changeBuyingType = (event, value) => {
    this.props.onChange('basicInfo', { ...this.props.value, buyingType: value, isLocalBusiness: 0 });
    this.setState({ websiteUrlErr: '' });
  }

  completeLicenseImageUrl = (response = {}, fileTarget, fileId) => {
    const value = response.file_url;

    this.props.onChange('basicInfo', { ...this.props.value, licenseImageUrl: value });
    this.inputValidate(value, 'licenseImageUrl');
  }

  changeLicenseImageUrl = (event, value) => {
    if (value instanceof Array && value.length === 0) value = '';
    this.props.onChange('basicInfo', { ...this.props.value, licenseImageUrl: value });
  }

  completeLegalPersonPositive = (response = {}, fileTarget, fileId) => {
    const value = response.file_url;

    this.props.onChange('basicInfo', { ...this.props.value, legalPersonPositive: value });
    this.inputValidate(value, 'legalPersonPositive');
  }

  changeLegalPersonPositive = (event, value) => {
    if (value instanceof Array && value.length === 0) value = '';
    this.props.onChange('basicInfo', { ...this.props.value, legalPersonPositive: value });
  }

  completeLegalPersonNegative = (response = {}, fileTarget, fileId) => {
    const value = response.file_url;

    this.props.onChange('basicInfo', { ...this.props.value, legalPersonNegative: value });
    this.inputValidate(value, 'legalPersonNegative');
  }

  changeLegalPersonNegative = (event, value) => {
    if (value instanceof Array && value.length === 0) value = '';
    this.props.onChange('basicInfo', { ...this.props.value, legalPersonNegative: value });
  }

  autoFillUrl = (url = '') => {
    const re = /^([a-zA-Z0-9-]+\.)+([a-zA-Z]{2,4})(\/[a-zA-Z0-9`~!@#%&_=;$^*()\-+{}[]:,\.\?\/\|]*)?$/;
    let result = url;

    if (re.test(url) && url.substr(0, 7) !== 'http://' && url.substr(0, 8) !== 'https://') {
      result = `http://${url}`;
    }
    return result;
  }

  handleLocalBusiness = (e, isLocalBusiness) => {
    this.props.onChange('basicInfo', { ...this.props.value, isLocalBusiness });
    this.setState({ websiteUrlErr: '' });
  }

  changeUname = (event, value) => {
    value = value.trim();
    if (value === this.props.value.uname) return;
    const params = {
      strParam: value,
    };
    this.props.onChange('basicInfo', { ...this.props.value, uname: value });
    this.companyNameVerify = false;
    this.fetchCompanyNameVerify(params);
  }

  fetchCompanyNameVerify = (params) => {
    const { webApi } = this.props;
    webApi
      .companyNameVerify()
      .dispatchJson(ActionTypes.CREATE_CLIENT, {
        data: params,
      })
      .then(
        (res) => {
          if (res === 'SUCCESS') {
            this.inputValidate(params.strParam, 'uname');
            this.companyNameVerify = true;
          }
        },
        (error) => {
          if (error) {
            this.setState({
              unameErr: '请输入正确的公司名称',
            });
          }
        },
      );
  }

  /*
   * 验证输入链接
   */
  validateSiteUrl = (value) => {
    // let val = $.trim(value) || '',
    const val = value.trim() || '';
    let result = true;
    let msg = '';

    const reg = /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/;
    const isJDLink = (link) => {
      const { agencyUid: agency_uid } = this.props;
      const is_jd_open_account_enable = _.get(globalStore.account, `feature_flag_list[${agency_uid}].is_jd_open_account_enable`, false);
      if (is_jd_open_account_enable) {
        return false;
      }
      const parser = document.createElement('a');
      parser.href = link;
      const host = parser.host;
      const hostRegex = /\.jd\.com$/;
      return hostRegex.test(host);
    };
    if (!val) {
      result = true;
      msg = '';
    } else if (!reg.test(val)) {
      result = false;
      msg = '请输入正确的公司网站,如:http://example.com/';
    } else if (isJDLink(val)) {
      result = false;
      msg = (
        <span>
          {' '}
          您的链接地址为京东链接，请前往开通
          <a href="https://jzt.jd.com">京东直投产品。</a>
        </span>
      );
    }

    return {
      result,
      msg,
    };
  }

  changeWebsiteUrl = (event, valueString) => {
    // let value = $.trim(valueString) || '';
    const value = valueString.trim() || '';
    const validateResult = this.validateSiteUrl(value) || {};
    const regTmall = /.*\.tmall\.com.*/gi;
    const tmall_advertiser_adtype = this.props.value.tmallAdvertiserAdtype;
    if (this.props.type === 'create' || this.props.editRegistration) {
      if (regTmall.test(value) && !this.state.showTmallAdvertiserAdType) {
        this.setState({ showTmallAdvertiserAdType: true });
      } else {
        if (tmall_advertiser_adtype) {
          this.props.onChange('basicInfo', { ...this.props.value, tmallAdvertiserAdtype: 0 });
        }
        this.setState({ showTmallAdvertiserAdType: false });
      }
    }

    this.props.onChange('basicInfo', { ...this.props.value, websiteUrl: value || '' });

    this.setState({
      websiteUrlErr: validateResult.msg || '',
    });
  }

  onSiteUrlBlur = (value) => {
    if (!value) {
      this.props.onChange('basicInfo', { ...this.props.value, websiteUrl: value || '' });
      return;
    }
    const val = this.autoFillUrl(value);
    const validateResult = this.validateSiteUrl(val) || {};

    this.props.onChange('basicInfo', { ...this.props.value, websiteUrl: this.autoFillUrl(value) });

    this.setState({
      websiteUrlErr: validateResult.msg || '',
    });
  }

  changeLicenseNo = (event, value) => {
    this.props.onChange('basicInfo', { ...this.props.value, licenseNo: value });
    this.inputValidate(value, 'licenseNo');
  }

  changeLegalPersonName = (event, value) => {
    this.props.onChange('basicInfo', { ...this.props.value, legalPersonName: value });
    this.inputValidate(value, 'legalPersonName');
  }

  changeAreaCode = (event, value) => {
    this.props.onChange('basicInfo', { ...this.props.value, areaCode: value });
    this.inputValidate(value, 'areaCode');
  }
  /**
   *法人身份证号码输入
   */
  changeLegalPersonIdentityNo = (event, value) => {
    // let val = $.trim(value) || '';
    const val = value.trim() || '';
    this.props.onChange('basicInfo', { ...this.props.value, legalPersonIdentityNo: val });
  }
  onLegalPersonIdentityNoBlur(value) {
    if (!value) {
      this.setState({
        legalPersonIdentityNoErr: '',
      });
      return;
    }
    const validateResult = this.validateLegalPersonIdentityNo(value) || {};
    this.setState({ legalPersonIdentityNoErr: validateResult.msg || '' });
  }
  // //验证法人身份证号
  validateLegalPersonIdentityNo = (value) => {
    // let val = $.trim(value) || '',
    const val = value.trim() || '';
    let result = true;
    let msg = '';
    if (!val) {
      result = false;
      msg = '请填写法人身份证号';
    } else if (val.length !== 18) {
      result = false;
      msg = '请填写正确的法人身份证号';
    }

    return {
      msg,
      result,
    };
  }

  validEachFieldIsEmpty = (type) => {
    const { isLocalBusiness } = this.props.value;
    let result = true;
    let map;
    if (type === 'GDT') {
      map = requiredFieldMapByGDT;
      if (isLocalBusiness) { // 附近推开户则跳过公司网站验证
        map = _.pickBy(map, (val, key) => key !== 'websiteUrl');
      }
    } else if ('WeChat') {
      map = requiredFieldMapByWeChat;
    }
    const keys = Object.keys(map);

    keys.forEach((key) => {
      const stateVal = this.props.value[key];
      const mapVal = map[key];
      const { tip, errField } = mapVal;

      if (key === 'tmallAdvertiserAdtype') {
        if (this.state.showTmallAdvertiserAdType) {
          if (stateVal === 0) {
            result = false;
            this.setState({
              [errField]: tip,
            });
          } else {
            this.setState({
              [errField]: '',
            });
          }
          return;
        }
        // 无需校验
        return;
      }

      if (!stateVal) {
        result = false;
        this.setState({
          [errField]: tip,
        });
      } else {
        this.setState({
          [errField]: '',
        });
      }
    });

    if (!this.companyNameVerify) {
      this.setState({
        unameErr: '请输入正确的公司名称',
      });
      result = false;
    }

    return result;
  }

  inputValidate = (value, field) => {
    const { tip, errField } = requiredFieldMap[field];
    if (value) {
      this.setState({
        [errField]: '',
      });
    } else {
      this.setState({
        [errField]: tip,
      });
    }
  }

  onChangeTmallAdType = (event, value) => {
    this.props.onChange('basicInfo', { ...this.props.value, tmallAdvertiserAdtype: value });
  }

  getDisabledStatus = (status) => {
    const result = {};
    const keys = Object.keys(basicInfoDisabledConfig);
    _.forEach(keys, (key) => {
      // value:比如为unameDisabled
      const statusArr = basicInfoDisabledConfig[key];
      let disabled = false;
      if (_.indexOf(statusArr, status) > -1) {
        disabled = true;
      }
      _.assign(result, { [key]: disabled });
    });
    return result;
  }

  resetErrStatus = () => {
    this.setState({
      unameErr: '',
      websiteUrlErr: '',
      tmallAdvertiserAdtypeErr: '',
      licenseNoErr: '',
      imgUploadUrlErr: '',
      areaCodeErr: '',
      legalPersonNameErr: '',
      legalPersonPositiveImageErr: '',
      legalPersonNegativeImageErr: '',
      legalPersonIdentityNoErr: '',
    });
  }

  renderEmptyComponent = (props) => {
    const { description, infoTop, infoBottom, uploadSize } = props;
    return (
      <span className="bg-tips-w">
        <span className="w-normal">{description ? description : '文字描述'}</span>
        <span className="w-bold">{infoTop ? `${infoTop},` : ''}点击或拖拽上传</span>
        <span className="w-small">
          {infoBottom ? `${infoBottom},` : ''}JPG/PNG,小于{uploadSize ? uploadSize : '2'}M
        </span>
      </span>
    );
  }

  render() {
    const { unameErr, websiteUrlErr, licenseNoErr, imgUploadUrlErr, areaCodeErr, legalPersonNameErr, legalPersonPositiveImageErr, legalPersonNegativeImageErr, legalPersonIdentityNoErr, showTmallAdvertiserAdType, tmallAdvertiserAdtypeErr } = this.state;
    const {
      type,
      accountStatus,
      value: { buyingType, uname, websiteUrl, licenseNo, areaCode, licenseImageUrl, legalPersonName, legalPersonIdentityNo, legalPersonPositive, legalPersonNegative, tmallAdvertiserAdtype, isLocalBusiness },
      editRegistration,
      platformType,
      accountData = {},
      registrationType,
    } = this.props;
    const { disabled, orderType } = accountData;
    const licenseImage = licenseImageUrl ? [{ url: licenseImageUrl, name: 'licenseImageUrl' }] : [];
    const legalPersonPositiveImage = legalPersonPositive ? [{ url: legalPersonPositive, name: 'legalPersonPositive' }] : [];
    const legalPersonNegativeImage = legalPersonNegative ? [{ url: legalPersonNegative, name: 'legalPersonNegative' }] : [];

    // 需要将子客的账户状态传递到BasicInfo组件中
    // 编辑子客账户时，需要根据账户状态设置可编辑的子客字段
    const { unameDisabled, buyingTypeDisabled, websiteUrlDisabled, licenseNoDisabled, licenseImageUrlDisabled, areaCodeDisabled, legalPersonNameDisabled, legalPersonPositiveDisabled, legalPersonNegativeDisabled, legalPersonIdentityNoDisabled } = this.getDisabledStatus(accountStatus);

    let adtypeContent = '';
    const showEntrance = true;

    // 修改的时候，不允许修改 开户类型、开户平台
    const disabledBuyingTypeByEdit = orderType === 'salesApply' ? disabled : type === 'edit';

    let buyingTypeData = _.map(enumMessages('BuyingType'), (message) => {
      return {
        value: message.value,
        label: message.message,
      };
    });
    buyingTypeData = _.compact(buyingTypeData);

    let isRequireClass;

    if (platformType === 'AD_PLATFORM_TYPE_GDT') {
      isRequireClass = ' required';
    } else {
      isRequireClass = '';
    }

    if (showEntrance && showTmallAdvertiserAdType && (editRegistration || type === 'create')) {
      adtypeContent = (
        <li className="infolist advertise-type">
          <span className="info-tt">广告类型</span>
          <div className="info-des">
            <ButtonGroup
              data={[
                {
                  key: TMALL_ADVERTISER_ADTYPE.FYEC,
                  value: TMALL_ADVERTISER_ADTYPE.FYEC,
                  label: '使用枫页电商平台建站',
                  tip: '投放腾讯域流量（具体流量准入需遵守平台规范)',
                },
                {
                  key: TMALL_ADVERTISER_ADTYPE.TMALL,
                  value: TMALL_ADVERTISER_ADTYPE.TMALL,
                  label: '仍使用天猫主域',
                  tip: '投放非腾讯域流量',
                },
              ]}
              value={tmallAdvertiserAdtype}
              onChange={this.onChangeTmallAdType}
              activeDisplayType="primary"
            />
            <div className="remark" style={{ marginTop: '10px' }}>
              <p>根据腾讯社交营销服务投放政策，天猫主域只能投放非腾讯域流量（如跟腾讯合作的外部广告流量）；</p>
              <p>
                如需投放腾讯域流量，请使用枫页电商平台建站投放。
                <OverlayTrigger trigger="hover" overlay={<PopOver>腾讯社交营销服务为电商广告主量身定做，用于创建商品落地页并进行订单管理的工具</PopOver>}>
                  <Icon className="icon-tmall-tip" type="tips" />
                </OverlayTrigger>
              </p>
            </div>
          </div>
          <span className="help-block">{tmallAdvertiserAdtypeErr || ''}</span>
        </li>
      );
    }

    return (
      <div className="lump">
        <h2 style={{ fontSize: '18px' }} className="lump-hd">
          基础信息
        </h2>
        <div className="lump-bd">
          <ul className="infos">
            <li className="infolist">
              <span className="info-tt">账户类型</span>
              <div className="info-des">
                <ButtonGroup data={buyingTypeData} disabled={disabledBuyingTypeByEdit} value={buyingType} onChange={this.changeBuyingType}>
                  {/* <Button value='ACCOUNT_BUYING_TYPE_AUCTION'
                                        disabled={buyingTypeDisabled}>
                                        竞价账户
                                </Button>
                                    <Button value='ACCOUNT_BUYING_TYPE_CONTRACT'
                                        disabled={buyingTypeDisabled}>
                                        合约账户
                                </Button> */}
                </ButtonGroup>
              </div>
            </li>
            <li className="infolist required">
              <span className="info-tt">公司名称</span>
              <div className="info-des">
                <FormGroup error={unameErr}>
                  <Input disabled={unameDisabled} placeholder="请输入公司名称" value={uname} onChange={this.changeUname} />
                </FormGroup>
              </div>
            </li>
            <li className={classNames('infolist', {
              [isRequireClass]: !isLocalBusiness,
            })}>
              <span className="info-tt">公司网站
                {
                  platformType === 'AD_PLATFORM_TYPE_GDT' && buyingType === 'BUYINGTYPE_AUCTION' && <Checkbox disabled={disabledBuyingTypeByEdit || registrationType === 'REGISTRATION_EXISTED'} style={{ marginLeft: 10 }} value={1} checked={!!isLocalBusiness} onChange={this.handleLocalBusiness}>
                    附近推账户
                  </Checkbox>
                }
              </span>
              <div className="info-des">
                <FormGroup error={websiteUrlErr}>
                  <Input placeholder="请输入公司网址" disabled={websiteUrlDisabled} value={websiteUrl} onChange={this.changeWebsiteUrl} onBlur={(event) => this.onSiteUrlBlur(event.target.value)} />
                </FormGroup>
              </div>
              <div className="extra">
                <p className="tips">链接仅证明公司主体，不用于广告</p>
              </div>
            </li>
            {adtypeContent}
            <li className={`infolist${isRequireClass}`}>
              <span className="info-tt">营业执照</span>
              <div className="info-des  info-des-upimg">
                <FormGroup style={{ marginBottom: '30px' }} error={licenseNoErr}>
                  <Input disabled={licenseNoDisabled} placeholder="请输入营业执照号码或三证合一统一社会信用代码" value={licenseNo} onChange={this.changeLicenseNo} />
                </FormGroup>
                <FormGroup error={imgUploadUrlErr}>
                  <ImageUploader
                    disabled={licenseImageUrlDisabled}
                    name="img"
                    EmptyComponent={() => {
                      return this.renderEmptyComponent({ description: '营业执照', uploadSize: '1' });
                    }}
                    data={{}}
                    url={imgUploadUrl}
                    value={licenseImage}
                    onChange={this.changeLicenseImageUrl}
                    onComplete={this.completeLicenseImageUrl}
                  />
                </FormGroup>
              </div>
            </li>
            <li className="infolist required">
              <span className="info-tt">公司所在地</span>
              <div className="info-des">
                <FormGroup error={areaCodeErr}>
                  <AreaSelect disabled={areaCodeDisabled} value={areaCode} onChange={this.changeAreaCode} />
                </FormGroup>
              </div>
            </li>
            <li className={`infolist${isRequireClass}`}>
              <span className="info-tt">法人姓名</span>
              <div className="info-des">
                <FormGroup error={legalPersonNameErr}>
                  <Input disabled={legalPersonNameDisabled} placeholder="请输入法人姓名" value={legalPersonName} onChange={this.changeLegalPersonName} />
                </FormGroup>
              </div>
            </li>
            <li className={`infolist infolist-tt-ver${isRequireClass}`}>
              <span className="info-tt">法人身份证正面</span>
              <div className="info-des info-des-upimg">
                <div className="upimg-area clearfix">
                  {/* <Upimg_sfz_zheng/><Upimg_sfz_fan/> */}
                  <FormGroup error={legalPersonPositiveImageErr}>
                    <ImageUploader
                      disabled={legalPersonPositiveDisabled}
                      name="img"
                      EmptyComponent={() => {
                        return this.renderEmptyComponent({ description: '身份证正面', infoTop: '身份证正面', infoBottom: '有年检章', uploadSize: '5' });
                      }}
                      data={{}}
                      url={imgUploadUrl}
                      value={legalPersonPositiveImage}
                      onChange={this.changeLegalPersonPositive}
                      onComplete={this.completeLegalPersonPositive}
                    />
                  </FormGroup>
                </div>
              </div>
            </li>
            <li className={`infolist infolist-tt-ver${isRequireClass}`}>
              <span className="info-tt">法人身份证反面</span>
              <div className="info-des info-des-upimg">
                <div className="upimg-area clearfix">
                  {/* <Upimg_sfz_zheng/><Upimg_sfz_fan/> */}
                  <FormGroup error={legalPersonNegativeImageErr}>
                    <ImageUploader
                      disabled={legalPersonNegativeDisabled}
                      name="img"
                      EmptyComponent={() => {
                        return this.renderEmptyComponent({ description: '身份证反面', infoTop: '身份证反面', infoBottom: '有年检章', uploadSize: '5' });
                      }}
                      data={{}}
                      url={imgUploadUrl}
                      value={legalPersonNegativeImage}
                      onChange={this.changeLegalPersonNegative}
                      onComplete={this.completeLegalPersonNegative}
                    />
                  </FormGroup>
                </div>
              </div>
            </li>
            <li className={`infolist${isRequireClass}`}>
              <span className="info-tt">法人身份证号</span>
              <div className="info-des">
                <FormGroup error={legalPersonIdentityNoErr}>
                  <Input disabled={legalPersonIdentityNoDisabled} placeholder="请输入法人身份证号" value={legalPersonIdentityNo} onChange={this.changeLegalPersonIdentityNo} onBlur={(event) => this.onLegalPersonIdentityNoBlur(event.target.value)} />
                </FormGroup>
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    response: state,
  };
}

export default withApi(connect(mapStateToProps)(BasicInfo));
